import { colors, fontWeight } from '@cobliteam/ui/theme';
import { cn } from '@cobliteam/ui/utils';
import { css } from 'emotion';
import L from 'leaflet';

import stopPlaceIconUrl from '../icons/ic_place.svg';
import geofencePlaceIconUrl from '../icons/ic_place_geofence.svg';
import idleIconUrl from '../icons/ic_warning.svg';

const icon = (hasGeofence: boolean) => css`
  cursor: pointer;
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));

  & > span {
    top: 4px;
    left: 50%;
    position: absolute;
    text-align: center;
    transform: translate(-50%);
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    color: ${hasGeofence ? colors.black.DEFAULT : colors.danger[9]};
  }

  & > #idle {
    top: 10px;
    left: 15px;
    position: absolute;
  }
`;

interface StopIconOptions {
  hasGeofence?: boolean;
  isIdle?: boolean;
  isAllowedToViewPlacesOfInterest?: boolean;
}

const StopIcon = (index: number, options: StopIconOptions = {}) => {
  const { hasGeofence = false, isIdle = false, isAllowedToViewPlacesOfInterest = false } = options;

  const showGeofence = hasGeofence && isAllowedToViewPlacesOfInterest;
  const iconUrl = showGeofence ? geofencePlaceIconUrl : stopPlaceIconUrl;
  const numberSpan = `<span>${index + 1}</span>`;
  const placeImage = `<img src="${iconUrl}" />`;
  const idleImage = isIdle ? `<img id="idle" src="${idleIconUrl}" />` : '';

  return new L.DivIcon({
    html: `<div class="${icon(showGeofence)}">${numberSpan}${placeImage}${idleImage}</div>`,
    iconSize: [27, 33],
    iconAnchor: [13.5, 33],
  });
};

export const StopIconComponent = ({ index, options = {} }: { index: number; options?: StopIconOptions }) => {
  const { hasGeofence = false, isIdle = false, isAllowedToViewPlacesOfInterest = false } = options;

  const showGeofence = hasGeofence && isAllowedToViewPlacesOfInterest;
  const iconUrl = showGeofence ? geofencePlaceIconUrl : stopPlaceIconUrl;
  const iconClass = icon(showGeofence);
  const idleImage = isIdle ? <img id='idle' src={idleIconUrl} /> : null;

  return (
    <div className={cn(iconClass, 'h-auto w-6 cursor-auto')}>
      <span>{index + 1}</span>
      <img src={iconUrl} />
      {idleImage}
    </div>
  );
};

export default StopIcon;
